const LoadStatuses = {
  ACTIVE: "ACTIVE",
  INACTIVE: "CANCELLED",
};

const LoadSaleLotStatuses = {
  DELIVERED: "DELIVERED",
  NOT_DELIVERED: "NOT_DELIVERED",
};

export const LoadStatusColorMap = {
  [LoadStatuses.ACTIVE]: "successGreen",
  [LoadStatuses.INACTIVE]: "errorRed",
};

export const LoadSaleLotStatusColorMap = {
  [LoadSaleLotStatuses.DELIVERED]: "successGreen",
  [LoadSaleLotStatuses.NOT_DELIVERED]: "warningOrange",
};
